module.exports = __webpack_public_path__ + "img/rate_gold.5c3aa145.jpg";